export default "__VITE_ASSET__Dhb_fBKm__"